import type { Router } from 'vue-router'
import { message } from 'vuekit'

import { MESSAGE_TIMEOUT } from '@ds/swymkit/config'

import { Navigation404Error, NavigationToModalError } from '~/router/errors'

export const navigationErrorHandler: Parameters<Router['onError']>[0] = async (error, _to, _from) => {
  if (error instanceof Navigation404Error) {
    const { useTranslations } = await import('~/features-generic/translations/composables/translations')

    const { $i18n, promise } = useTranslations('error')
    await promise

    message.create({
      text: $i18n('ThisContentDoesntExist'),
      timeout: MESSAGE_TIMEOUT,
    })
  }
  else if (error instanceof NavigationToModalError) {
    useEventBus('swym-app')
      .emit('modal-manager:open', {
        component: error.modal,
        props: error.props,
      })
  }
}
